import React, { useState, useEffect } from "react";
//Material UI Styles
import { lighten, makeStyles, styled } from "@material-ui/core/styles";

import GlobalApi from "./../../Global";
import List from "@material-ui/core/List";
import Checkbox from "@material-ui/core/Checkbox";
import refresh_token from "./../../Global/refresh_token";
import { Paper, Typography, Grid } from "@material-ui/core";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import _ from "lodash";
import Tooltip from "@material-ui/core/Tooltip";
import { useHistory } from "react-router-dom";
import Popover from "@material-ui/core/Popover";
import Colors from "./../../Global/colors";
import Spinner from "./../../Global/Spinner";
import Button from "@material-ui/core/Button";
import NoRecords from "./../../Global/NoRecords";
import DoneAll from "@material-ui/icons/DoneAll";
import InputAdornment from "@material-ui/core/InputAdornment";
import Check from "@material-ui/icons/Mail";
import moment from "moment";
import MiddleHeader from "../../views/middleHeader/middleHeader";
import { useSelector, useDispatch } from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import { updateNotification } from "../../Redux/Actions/notificationAction";
import add from "../../Assets/add.png";
import search from "../../Assets/search.png";
import filter from "../../Assets/Filter_Icon.png";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

export default function Notification() {
  const {t} = useTranslation();
  const classes = useStyles();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const history = useHistory();
  const [notifications, setNotifications] = React.useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedNotificataions, setSelectedNotificataions] = React.useState(
    []
  );
  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [searchText, setSearchText] = useState("");
  const [notificationLoader, setNotificationLoader] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterMenu5, setFilterMenu5] = React.useState(null);
  const [selectAll, setSelectAll] = React.useState(false);
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startFlag: false,
    endFlag: false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const dispatch = useDispatch();


  console.log(":::::::::::::::::::::::::::::::::::::::::",selectedNotificataions)
  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };

  const handleClick7 = async (event) => {
    setFilterMenu5(event.currentTarget);
  };

  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose7 = () => {
    setFilterMenu5(null);
  };

  const readNotification = ()=>{
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      company_id: company.id,
      notification_arr :JSON.stringify(selectedNotificataions),
      is_read: true,
      is_deleted:false,
    };
 

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/read_selected_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from notifications read", response);
        if (response.msg === "success") {
          dispatch(updateNotification(company.id));
          setSelectedNotificataions([])
          if (
            datesFilters.today == true ||
            datesFilters.yesterday == true ||
            datesFilters.last7 == true ||
            datesFilters.last15 == true ||
            datesFilters.lastMonth == true ||
            datesFilters.startFlag == true ||
            datesFilters.endFlag == true
          ) {
            setFilterApplied(true);
            getNotifications(false);
          } else {
            setFilterApplied(false);
            getNotifications(true);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  const deleteNotification = ()=>{
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      company_id: company.id,
      notification_arr :JSON.stringify(selectedNotificataions),
      is_read: false,
      is_deleted:true,
    };
 

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/read_selected_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from notifications read", response);
        if (response.msg === "success") {
          dispatch(updateNotification(company.id));
          setSelectedNotificataions([])
          if (
            datesFilters.today == true ||
            datesFilters.yesterday == true ||
            datesFilters.last7 == true ||
            datesFilters.last15 == true ||
            datesFilters.lastMonth == true ||
            datesFilters.startFlag == true ||
            datesFilters.endFlag == true
          ) {
            setFilterApplied(true);
            getNotifications(false);
          } else {
            setFilterApplied(false);
            getNotifications(true);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  const handleCancel = ()=>{
    setSelectedNotificataions([])
  }

  const handleToday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: !datesFilters.today,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handleYesterday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: !datesFilters.yesterday,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle7Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: !datesFilters.last7,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle1Month = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: !datesFilters.lastMonth,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handleStartDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: true,
      endFlag: false,
      startDate: e.target.value,
    };
    console.log(_datesFilters);
    setDateFilters(_datesFilters);
  };

  const handleEndDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: true,
      endDate: e.target.value,
    };
    setDateFilters(_datesFilters);
  };

  const clearDatesFilter = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setFilterApplied(false);
    setDateFilters(_datesFilters);
    getNotifications(true);
  };


  const selectNotification = (checked, item) =>{
    const nextselectedNotification = checked
    ? [...selectedNotificataions, item.id]
    : selectedNotificataions.filter((t) => t !== item.id);
  setSelectedNotificataions(nextselectedNotification);
  }

  const selectAllNotifications = (checked) =>{
    let allNotifications = []
    if(checked){
      notifications.forEach(item=>{
        allNotifications.push(item.id)
      })
      setSelectAll(true)
    }else{
      setSelectAll(true)
    }
    setSelectedNotificataions(allNotifications);
  }
  
  const handleDone2 = () => {
    document.getElementById("NotificationScroll").scrollTo(0,0);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getNotifications(false);
    } else {
      setFilterApplied(false);
      getNotifications(true);
    }
    setFilterMenu1(null);
    setFilterMenu5(null);
  };

  const open = Boolean(filterMenu1);

  const open5 = Boolean(filterMenu5);

  function getNotifications(reset) {
    setNotificationLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      skip:0,
      noOfRecords:15,
      user_id: data?.user_id,
      company_id: company.id,
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset ? undefined : moment(datesFilters.endDate).add(1, "d").format("YYYY-MM-DD"),
    };
 

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/get_all_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from notifications", response);
        if (response.status === "Success") {
          setTotalRecords(response.total_records)
          setNotificationLoader(false);
          console.log(")))))))))))))))))))))))))))))))))))))",response.data);
          setNotifications(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setNotificationLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getNotifications();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getMoreNotifications(reset) {
    
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      skip:notifications.length,
      noOfRecords:15,
      user_id: data?.user_id,
      company_id: company.id,
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset ? undefined : moment(datesFilters.endDate).add(1, "d").format("YYYY-MM-DD"),
    };
 

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/get_all_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from notifications", response);
        if (response.status === "Success") {
          setTotalRecords(response.total_records)
          setNotificationLoader(false);
          console.log(response.data);
          setNotifications([...notifications , ...response.data]);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setNotificationLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getNotifications();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }


  const handleScroll = (e) => {
    let currentRecords = notifications.length;
    
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      if(currentRecords !== totalRecords){
    

        if(datesFilters.today == true || 
          datesFilters.yesterday == true ||
          datesFilters.last7 == true ||
          datesFilters.last15 == true ||
          datesFilters.lastMonth == true ||
          datesFilters.startFlag == true ||
          datesFilters.endFlag == true){
            setFilterApplied(true)
            getMoreNotifications(false);
          }else{
            setFilterApplied(false)
            getMoreNotifications(true);
          }        
      }
     
    }
  };


  function updateNotifications(notifyID) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/edit_notification_status", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        id: notifyID,
        is_read: true,
        user_id: params.user_id,
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          console.log("ipdated");
          dispatch(updateNotification(company.id));
        }
      })
      .catch((error) => console.log(error.message));
  }

  React.useEffect(
    () => {
      getNotifications(true);
    },
    [company?.id]
  );

  // if (notifications === null) {
  //   return <Spinner/>;
  // } else {
  return <>
      <MiddleHeader />
      <div style={{ padding: "0px", display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: Colors.globalColor9 }}>
        <div className="" id="NotificationScroll" onScroll={(e) => handleScroll(e)} style={{height:'100vh', padding: 20, width: "100%", textAlign: "left", overflowY: "auto", backgroundColor: Colors.globalColor9 }}>
          
          <Grid container spacing={1} className="shadow" direction="row" justifyContent="flex-start" alignItems="center" style={{ backgroundColor: "white", borderRadius: "5px", padding: "5px 10px", marginBottom: "10px", display: "flex", justifyContent: "flex-start" }}>
          <Grid item xs={12} lg={12} justifyContent="flex-start">
          <Grid container xs={12} spacing={1} justifyContent="space-between" style={{justifyContent:'space-between'}}>
          <Grid item xs={12} lg={4} justifyContent={language =="ar" ? "flex-end": "flex-start"} style={{textAlign:language =="ar" ? "right": "left"}}>
          <p className="label2" style={{ display: "inline",textAlign:"right", marginTop: 0, fontSize: 16, color: Colors.globalColor8, textTransform: "uppercase" }}>
                    {t("Notifications")}
                  </p>
          </Grid>
          <Grid item xs={12} lg={4} justifyContent="flex-end" style={{textAlign:language == "ar"? "left" : "right"}}>
          {searchText == "" && <p className="label2" style={{ display: "inline", marginTop: 10, fontSize: 10, color: "grey", textTransform: "capitalized" }}>
          {t("showing records")} {notifications.length} {t("of")} {totalRecords}
                        {/* {"( " + packageDetails?.count + "/" + (packageDetails?.data === "Unlimited" ? "~" : packageDetails?.data) + " Templates have been created )"} */}
                      </p>}
          </Grid>
          </Grid>
            </Grid>

            <Grid item xs={2} lg={1} justifyContent="flex-start">
              <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", cursor: "pointer" }}>
                <Checkbox className="filterCheckbox" style={{ paddingRight: 0, color: Colors.globalColor8 }} onChange={(e) => selectAllNotifications(e.target.checked)} />
              </div>
            </Grid>

            <Grid item xs={10} lg={4} alignItems="flex-start">
              <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>, endAdornment: <InputAdornment position="end">
                      <Tooltip title="Filter Options">
                        <img src={filter} width={20} style={{ cursor: "pointer" }} onClick={handleClick3} />
                      </Tooltip>
                    </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search in Notifications")} fullWidth onChange={(e) => setSearchText(e.target.value)} variant="outlined" style={{ width: "100%", backgroundColor: Colors.globalColor5 }} />

              {/* =================================popover 1=========================== */}

              <Popover open={open} anchorEl={filterMenu1} onClose={handleClose3} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
                <div style={{ width: "150px", backgroundColor: "white", borderRadius: "5px", padding: "0px" }}>
                  <List component="nav" aria-label="secondary mailbox folders">
                    <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick7(e)}>
                      <ListItemText primary={t("Dates")} />
                    </ListItem>
                  </List>
                </div>
              </Popover>

              {/* =================================popover 5=========================== */}
              <Popover open={open5} anchorEl={filterMenu5}  onClose={handleClose7} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "right" }} style={{ margin: "20px" }}>
                <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                  <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                    {t("Select Date Range")}
                  </p>
                  <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.today} onChange={() => handleToday()} />
                    <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                      {t("Today")}
                    </p>
                  </span>
                  <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.yesterday} onChange={() => handleYesterday()} />
                    <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                      {t("Yesterday")}
                    </p>
                  </span>
                  <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last7} onChange={() => handle7Days()} />
                    <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                      {t("Last 7 Days")}
                    </p>
                  </span>
                  {/* <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last15} onChange={()=>handle15Days()} />
                    <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                      Last 15 Days
                    </p>
                  </span> */}
                  <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.lastMonth} onChange={() => handle1Month()} />
                    <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                      {t("Last Month")}
                    </p>
                  </span>
                  <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                    {t("Custom Range")}
                  </p>

                  {/* <KeyboardDatePicker className="filterDatePicker" disableToolbar label="From Date"  format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.startDate} onChange={handleStartDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                  {/* <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 10 }} /> */}
                  <form className={classes.container} noValidate>
                    <TextField variant="outlined" className="filterDatePicker" label={t("From Date")} type="date" size="small" fullwidth value={datesFilters.startDate} onChange={handleStartDate} style={{ width: "100%", marginTop: "10px" }} InputLabelProps={{ shrink: true }} />
                    <TextField variant="outlined" className="filterDatePicker" label={t("To Date")} type="date" size="small" fullwidth value={datesFilters.endDate} onChange={handleEndDate}  style={{ width: "100%", marginTop: "10px" }} InputLabelProps={{ shrink: true }} />
                    {/* <KeyboardDatePicker className="filterDatePicker" style={{ marginTop: "10px", marginBottom: "10px" }} disableToolbar label="To Date" variant="outlined" format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.endDate} onChange={handleEndDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                  </form>
                  <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                  <Button className="ctBtn" onClick={() => handleDone2()}>
                    {/* onClick={() => onSelectAccess()} */}
                    {t("Done")}
                  </Button>
                </div>
              </Popover>
            </Grid>

            <Grid item xs={4} lg={1} style={{textAlign:'center'}}>
              {selectedNotificataions.length > 0 && 
                  <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                    <Button onClick={()=>readNotification()}>
                      <p className="label2" style={{ fontSize: 12, fontWeight: "bold", margin: "auto", color: Colors.globalColor8, textTransform: "uppercase" }}>
                        {t("Read")}
                      </p>
                    </Button>
                </div>}
            </Grid>

            <Grid item xs={4} lg={1} style={{textAlign:'center'}}>
              {selectedNotificataions.length > 0 && 
                  <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                    <Button onClick={()=>deleteNotification()}>
                      <p className="label2" style={{ fontSize: 12, fontWeight: "bold", margin: "auto", color: Colors.globalColor8, textTransform: "uppercase" }}>
                        {t("Delete")}
                      </p>
                    </Button>
                </div>}
            </Grid>

            <Grid item xs={4} lg={1} style={{textAlign:'center'}}>
              {selectedNotificataions.length > 0 && 
                  <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                    <Button onClick={()=>handleCancel()}>
                      <p className="label2" style={{ fontSize: 12, fontWeight: "bold", margin: "auto", color: Colors.globalColor8, textTransform: "uppercase" }}>
                        {t("Cancel")}
                      </p>
                    </Button>
                </div>}
            </Grid>

            <Grid item xs={6} lg={4}>
              {filterApplied && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer", width: "400px" }}>
                  <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                    <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                      {datesFilters.today && "Today"}
                      {datesFilters.yesterday && "Yesterday"}
                      {!datesFilters.today && !datesFilters.yesterday && `From : ${moment(datesFilters.startDate).format("DD-MM-YY")} - To: ${moment(datesFilters.endDate).format("DD-MM-YY")}`}
                    </div> <div onClick={() => clearDatesFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                      x
                    </div>
                  </div>
                </div>}
            </Grid>
          </Grid>

          {notificationLoader && <Spinner />}
          {!notificationLoader && <Paper elevation={0} style={{ backgroundColor: Colors.globalColor9, padding: 0, width:'100%' }}>
              {notifications.length > 0 ? notifications
                  ?.sort((a, b) => parseInt(new Date(b.createdAt).getTime()) - parseInt(new Date(a.createdAt).getTime()))
                  .filter((v) => v.title
                        ?.toLowerCase()
                        .includes(
                          searchText?.toLowerCase()
                        ) || v.details
                        ?.toLowerCase()
                        .includes(searchText?.toLowerCase()))
                  .map((item) => {
                    console.log(JSON.stringify(item));
                    return <Paper elevation={0} variant={"outlined"} style={{ backgroundColor: "white", padding: "5px 10px", margin: "5px 0px", display: "flex", alignItems: "center" }} className="new-hover">
                        <Grid spacing={2} container direction="row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <Grid item>
                            <Grid spacing={2} container direction="row" style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                              <Grid item>
                                <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectNotification(e.target.checked, item)} checked={selectedNotificataions.indexOf(item.id) > -1} />
                              </Grid>
                              <Grid item>
                                {item.is_read == true ? <DoneAll size={"small"} style={{ color: Colors.globalColor8, marginTop: "5px" }} /> : <Check size={"small"} style={{ marginTop: "5px", color: Colors.globalColor8 }} />}
                              </Grid>

                              <div style={{ display: "flex", flexDirection: "row" }} onClick={() => {
                                  updateNotifications(item.id);
                                  if (item.type == "Schedule Assigned") {
                                    history.push("/schedule-edit/" + item.refrence);
                                  } else {
                                    history.push(item.refrence);
                                  }
                                  //
                                }}>
                                <Grid item>
                                  <p className="label2" style={{ fontSize: 14, fontWeight: "bold", margin: "auto", color: Colors.globalColor8, textTransform: "uppercase" }}>
                                    {item.title}
                                  </p>
                                </Grid>
                                &emsp;
                                <Grid item style={{ overflow: "auto", whiteSpace: "no-wrap" }}>
                                <Tooltip title={item?.details ? item?.details : " " }>
                                <p className="label2" style={{ fontWeight: "normal", margin: "auto", fontSize: 14, color: "grey", textTransform: "capitalized" }}>
                           {item?.details.slice(0, 100) + (item?.details?.length > 100 ? "..." : "")}
                           </p>
                           </Tooltip>
                                
                                  {/* {item.meta_data !== null && <p className="label2" style={{ fontWeight: "normal", margin: "auto", fontSize: 14, color: "grey", textTransform: "capitalized" }}>
                                     {item?.meta_data.slice(0, 50) + (item?.meta_data.length > 50 ? "..." : "")}
                                    </p>} */}
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>

                          <Grid item>
                            <p className="label2" style={{ fontSize: 14, fontWeight: "bold", margin: "auto", color: Colors.globalColor8, textTransform: "lowercase" }}>
                              {new Date(item.createdAt).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0) ? moment(item.createdAt).format("h:mm A") : moment(item.createdAt).format("DD MMM")}
                            </p>
                          </Grid>
                        </Grid>

                        {/* <Typography variant="p" style={{ display: "block" }}>
                    {item.is_read == true ? "Reviewed" : "Review Now"}
                  </Typography> */}
                      </Paper>;
                  }) :   <div
                  style={{
                    padding: "20px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60vh",
                  }}
                >
                  <NoRecords />
                </div>}
            </Paper>}
          
        </div>
      </div>
    </>;
  // }
}
